import fetch from '../fetch';
import EndPoints from '../../data/EndPoints';
import Methods from '../../data/Methods';

export default (data) => {
	const headers = { 'content-type': 'application/json' };
	return fetch(Methods.GET, EndPoints.COMPANIES_BANKBOOK_CATEGORIES, data, headers, true);
};
